import { useTranslation } from "react-i18next";
import {
  Box,
  Heading,
  Text,
  Container,
  Stack,
  Flex,
  useBreakpointValue,
  useColorModeValue,
} from "@chakra-ui/react";
import { trackClick } from '../ga';
export default function AboutPage() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const orgColor = "#ec562c";
  const bluColor = "#2f4280";
  const textColor = useColorModeValue("gray.700", "gray.100");
  return (
    <Box py={10} bgGradient="linear(to-b, #ffffff, #2f4280)" onClick={() => trackClick(`Clicked about page`)}>
      <Container maxW="7xl" pt={"50px"}>
        {/* ABOUT */}


        <Heading
          textAlign="center"
          mb={4}
          fontSize="4xl"
          color={bluColor}
          fontWeight="bold"
        >
          {t("about.title")}
        </Heading>
        <Text
          textAlign="center"
          fontSize="lg"
          color={textColor}
          maxW="3xl"
          mx="auto"
          mb={10}
        >
          {t("about.description")}
        </Text>

        {/* VISION */}
        <Flex
          mt={10}
          direction={{ base: "column", md: "row" }}
          bg="white"
          boxShadow="xl"
          borderRadius="2xl"
          overflow="hidden"
          p={{ base: 6, md: 10 }}
         
        >
          <Box flex="1" textAlign={isArabic ? "right" : "left"}>
            <Heading size="lg" color={orgColor} mb={4}>
              {t("vision.title")}
            </Heading>
            <Text fontSize={{ base: "sm", md: "md" }} color="gray.700">
              {t("vision.description")}
            </Text>
          </Box>
        </Flex>

        {/* MISSION */}
        <Flex
          mt={10}
          direction={{ base: "column", md: "row-reverse" }}
          bg={bluColor}
          boxShadow="xl"
          borderRadius="2xl"
          overflow="hidden"
          p={{ base: 6, md: 10 }}
        >
          <Box flex="1" textAlign={isArabic ? "right" : "left"}>
            <Heading size="lg" color="white" mb={4}>
              {t("mission.title")}
            </Heading>
            <Text fontSize={{ base: "sm", md: "md" }} color="gray.200">
              {t("mission.description")}
            </Text>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
}